import { SelectOption } from './select-option';

export const IncrementCodes = {
	Days: 'D',
	Months: 'M',
	Weeks: 'W',
	Years: 'Y',
};

export const IncrementPeriods = [
	{ code: IncrementCodes.Days, description: 'Days' },
	{ code: IncrementCodes.Weeks, description: 'Weeks' },
	{ code: IncrementCodes.Months, description: 'Months' },
	{ code: IncrementCodes.Years, description: 'Years' },
];

export const IncrementSelectOptions: SelectOption[] = IncrementPeriods.map((period) => ({
	label: period.description,
	value: period.code,
}));

export const Name_MiscellaneousFolder = 'Miscellaneous';

export const STATUS = {
	PENDING: 'P',
	APPROVED: 'A',
	OVERRIDDEN: 'O',
	REFUSED: 'R',
};

export const TAKEN = {
	UNKNOWN: 'U',
	TAKEN: 'T',
	NOT_TAKEN: 'N',
};

export const TRXTYPE = {
	SHIFT: 'S',
	WORK_PATTERN: 'W',
	LEAVE: 'L',
	UNAVAILABLE_HARD: 'UH',
	UNAVAILABLE_SOFT: 'US',
	AVAILABLE: 'A',
};

export const TRXCONTRACTTYPE = {
	CONTRACT: 'C',
	CONTRACT_AS_BANK: 'C as B',
	AGENCY: 'A',
	BANK: 'B',
};

export const Indicator_Primary = 'P';
export const Indicator_Secondary = 'S';
